export default __webpack_public_path__ + "static/media/ic-edx.f647c5ee.svg";